import type { IconSvgObject } from './types';

const Chip02Icon: IconSvgObject = [
  ["path", { d: "M12 2V6M12 18V22M21.9992 12H17.9992M6 12.0005H2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "12", r: "6", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 12C11.1716 12 10.5 12.5596 10.5 13.25C10.5 13.9404 11.1716 14.5 12 14.5C12.8284 14.5 13.5 13.9404 13.5 13.25C13.5 12.5596 12.8284 12 12 12ZM12 12C12.8284 12 13.5 11.4404 13.5 10.75C13.5 10.0596 12.8284 9.5 12 9.5C11.1716 9.5 10.5 10.0596 10.5 10.75C10.5 11.4404 11.1716 12 12 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export default Chip02Icon;
